import React from 'react';
import ListSubheader from '@material-ui/core/ListSubheader';


const About = () => (
  <div>

    <ListSubheader component="div" style={{ fontSize:'2em' }}>
    Hi, I like to Code, Create, Design & Live Life.
    </ListSubheader>

  </div>
)

export default About;
